import { gql } from "@apollo/client";
import FormDialog from "controls/FormDialog";
import { useActionFragment } from "hooks/useAction";
import useData from "hooks/useData";
import useIsAdmin from "hooks/useIsAdmin";
import { Cog } from "mdi-material-ui";
import React from "react";

import CourtsForm, { CourtsFormFragment } from "./Form";

CourtsEditDialog.useButtonProps = () => {
  const isAdmin = useIsAdmin();

  return {
    hidden: !isAdmin,
    icon: <Cog />,
    content: "Edit",
  };
};

export default function CourtsEditDialog({ courtIds, onSubmit, onClose }) {
  const courtsUpdate = useActionFragment("courtsUpdate");
  const [data, dataMeta] = useData(
    gql`
      query CourtsEditDialog($courtIds: [ID!]!) {
        courts(ids: $courtIds) {
          id
          ...CourtsFormFragment
        }
      }
      ${CourtsFormFragment}
    `,
    { courtIds },
  );

  return (
    <FormDialog
      header="Edit Court"
      loading={dataMeta.loading}
      onClose={onClose}
      onSubmit={async (formData) => {
        await courtsUpdate({
          input: {
            courtIds,
            ...formData,
          },
        });
        await onSubmit?.();
      }}
    >
      <CourtsForm courts={data?.courts} />
    </FormDialog>
  );
}
